import {useNavigate} from "react-router-dom"
import {authAxios} from "lib/http/http.common"
import {AccessTokenInfo} from "dto/auth/Authentication"
import {setLocalAccessToken} from "lib/http/token-management"
import {SubmitHandler, useForm} from "react-hook-form"
import {FormErrorBox} from "common/FormErrorBox"
import {showNotification} from "common/Notification"
import request from "axios"
import {ApiResponse} from "api/common/response"

type Inputs = {
    userId: string,
    password: string,
}
export const LoginForm = () => {
    const navigate = useNavigate()
    const {register, handleSubmit, formState: {errors}} = useForm<Inputs>()
    const login = async (userId: string, password: string) => {
        const response = await authAxios.post<ApiResponse<AccessTokenInfo>>("/auth", {
            userId,
            password,
        })
        await setLocalAccessToken(response?.data?.body)
        // const params = new URLSearchParams()
        // params.append("client_id", "public")
        // params.append("grant_type", "password")
        // params.append("username", userId)
        // params.append("password", password)
        // const response = await authAxios.post<AccessTokenInfo>("", params)
        // await setLocalAccessToken(response?.data)
    }
    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        try {
            await login(data.userId, data.password)
            navigate("/");
        } catch (error) {
            if(request.isAxiosError(error) && error.response) {
                console.log((error.response?.data))
            }
            showNotification("아이디나 비밀번호가 올바르지 않습니다.")
        }
    }
    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="login-body-all">
                <div className="login-box">
                    <div className="login-header">
                        {/*<div><img src="img/i-main-logo.png" alt="완주군 전동휠테어 모니터링 시스템"/></div>*/}
                        <span className="login-header-text">
                            {process.env.REACT_APP_ORGANIZATION}
                        </span> 전동휠체어 넘어짐 감지/추적시스템
                    </div>
                    <div className="login-content">
                        <div className="login-from">

                            <input type="text"
                                   {...register("userId", {required: "아이디를 입력하세요!",})}
                                   className="input-login" placeholder="Username"
                                   // defaultValue="gomipapa"
                            />
                            <FormErrorBox error={errors.userId}/>
                            <input type="password"
                                   {...register("password", {required: "비밀번호를 입력하세요!"})}
                                   className="input-login"
                                   placeholder="Password"
                                   // defaultValue="qkr2902!"
                            />
                            <FormErrorBox error={errors.password}/>
                            <div className=" mt10">
                                <button className="btn btn-login is-fullwidth">LOGIN</button>
                            </div>

                            <div className="copy">Copyright (c) ${process.env.REACT_APP_ORGANIZATION} All rights reserved</div>

                        </div>
                    </div>
                </div>

            </div>
        </form>
    )
}
